import React from 'react';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import Share from 'components/partials/Share';
import Bookmark from './Bookmark';
import { Icon } from 'components/Icon';
import { Facility } from 'types/Facility';

interface FacilityActionsProps {
    facility: Facility
    authed: boolean
    reg_type: number
    facility_id: string | number
}

const FacilityActions: React.FC<FacilityActionsProps> = ({
    facility,
    authed,
    reg_type,
    facility_id,
}) => {
    const isWebsite = facility?.website?.split('://')[1];

    return (
        <>
            <hr className="d-lg-none" />
            <div className="mb-3 d-flex justify-content-lg-between justify-content-end gap-xs-2">
                <div className="d-flex gap-xs-4 w-100">
                    {authed && Number(reg_type) === 2 && (
                        <div className="mr-auto mr-lg-0">
                            <Bookmark facility_id={facility_id} />
                        </div>
                    )}
                    {facility.phone && (
                        <a href={`tel://${facility.phone}`} className="phone d-flex gap-xs-2 align-items-center">
                            <Icon icon={faPhone} size="2x" />
                            <span className="d-none d-md-block" id="facility-homepage-phone">{facility.phone}</span>
                        </a>
                    )}
                    {isWebsite && (
                        <a
                            id="facility-link"
                            href={facility.website}
                            title={facility.website}
                            target="_blank"
                            rel="nofollow noopener"
                            className="phone d-flex gap-xs-2 align-items-center"
                        >
                            <i className="fa fa-2x fa-desktop mr-2" />
                            <span className="d-none d-md-block">Facility Website</span>
                        </a>
                    )}
                </div>
                <div>
                    <Share
                        component="facility-homepage"
                        page={facility_id}
                        text={`Storagetreasures.com | Facility homepage ${facility?.facility_name}`}
                    />
                </div>
            </div>
        </>
    );
};

export default FacilityActions;